import _inheritsLoose from "@babel/runtime-corejs3/helpers/inheritsLoose";
import _extends from "@babel/runtime-corejs3/helpers/extends";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import _trimInstanceProperty from "@babel/runtime-corejs3/core-js/instance/trim";
import _sliceInstanceProperty from "@babel/runtime-corejs3/core-js/instance/slice";
import _spliceInstanceProperty from "@babel/runtime-corejs3/core-js/instance/splice";
import { __decorate } from "tslib";
/**
 * The base hook for handling value of Datepicker and Timepicker
 */
import { useInstance } from 'intact-vue';
import { useState, watchState } from '../../hooks/useState';
import dayjs from './dayjs';
import { findValueIndex } from './helpers';
import { isEqualArray, last, bind } from '../utils';
import { BaseSelect } from '../select/base';
var typeDefs = _extends({}, BaseSelect.typeDefs, {
  value: [String, Array, Date, Number, dayjs.Dayjs],
  range: Boolean,
  format: String,
  valueFormat: String,
  showFormat: String,
  min: [String, Date, Number, dayjs.Dayjs],
  max: [String, Date, Number, dayjs.Dayjs],
  disabledDate: Function
});
var defaults = function defaults() {
  return _extends({}, BaseSelect.defaults(), {
    filterable: true
  });
};
var events = _extends({}, BaseSelect.events, {
  selecting: true
});
export var BasePicker = /*#__PURE__*/function (_BaseSelect) {
  _inheritsLoose(BasePicker, _BaseSelect);
  function BasePicker() {
    return _BaseSelect.apply(this, arguments) || this;
  }
  var _proto = BasePicker.prototype;
  _proto.resetKeywords = function resetKeywords(keywords) {
    var _this$get = this.get(),
      multiple = _this$get.multiple,
      range = _this$get.range;
    var dayjsValue = this.value.getDayjsValue();
    var getShowString = this.formats.getShowString;
    var value = last(dayjsValue);
    keywords.set(multiple ? '' : !range ? value ? getShowString(value) : '' : value ? [getShowString(value[0]), getShowString(value[1])].join(' ~ ') : '');
  };
  return BasePicker;
}(BaseSelect);
BasePicker.typeDefs = typeDefs;
BasePicker.defaults = defaults;
BasePicker.events = events;
__decorate([bind], BasePicker.prototype, "resetKeywords", null);
export function useValue(_ref, _ref2, panel, shouldUpdateValue, updateValueOnInput, getEqualType, updateStateValue) {
  var createDateByValueFormat = _ref.createDateByValueFormat,
    createDateByShowFormat = _ref.createDateByShowFormat,
    getShowString = _ref.getShowString,
    getValueString = _ref.getValueString;
  var isDisabled = _ref2.isDisabled,
    minDate = _ref2.minDate;
  // Normalize the value to multipe values, no matter it's multipe or not
  var value = useState([]);
  var instance = useInstance();
  var dayjsValue = [];
  instance.watch('value', function (newValue, oldValue) {
    if (isEqualArray(newValue, oldValue)) return;
    dayjsValue = convertToDayjs(newValue);
    updateStateValue(dayjsValue, value);
    // should update keywords
    instance.resetKeywords(instance.input.keywords);
  });
  watchState(instance.input.keywords, function (v) {
    var _instance$get = instance.get(),
      range = _instance$get.range,
      multiple = _instance$get.multiple;
    if (!multiple && v === '') return instance.set('value', null);
    if (range) {
      var _context;
      var _v$split$map = _mapInstanceProperty(_context = v.split(/\s*~\s*/)).call(_context, function (s) {
          return _trimInstanceProperty(s).call(s);
        }),
        start = _v$split$map[0],
        end = _v$split$map[1];
      if (start && end) {
        var startDate = createDateByShowFormat(start);
        if (!isValidDate(startDate)) {
          return;
        }
        var endDate = createDateByShowFormat(end);
        if (!isValidDate(endDate)) {
          return;
        }
        if (endDate.isAfter(startDate)) {
          updateValueOnInput([startDate, endDate]);
        }
      }
    } else {
      var date = createDateByShowFormat(v);
      if (isValidDate(date)) {
        updateValueOnInput(date);
      }
    }
  });
  function convertToDayjs(v) {
    if (!v || Array.isArray(v) && !v.length) return [];
    var _instance$get2 = instance.get(),
      multiple = _instance$get2.multiple;
    if (!multiple) {
      v = [v];
    }
    return _mapInstanceProperty(v).call(v, function (value) {
      if (Array.isArray(value)) {
        // range
        return _mapInstanceProperty(value).call(value, createDateByValueFormat);
      }
      return createDateByValueFormat(value);
    });
  }
  function convertToValueString(v) {
    var results = _mapInstanceProperty(v).call(v, function (value) {
      if (Array.isArray(value)) {
        return _mapInstanceProperty(value).call(value, getValueString);
      }
      return getValueString(value);
    });
    if (!instance.get('multiple')) {
      return results[0] || null;
    }
    return results;
  }
  function format() {
    var results = _mapInstanceProperty(dayjsValue).call(dayjsValue, function (value) {
      if (Array.isArray(value)) {
        return _mapInstanceProperty(value).call(value, getShowString).join(' ~ ');
      }
      return getShowString(value);
    });
    if (!instance.get('multiple')) {
      return results[0];
    }
    return results;
  }
  function setSingleDate(v, fromInput) {
    var _instance$get3 = instance.get(),
      range = _instance$get3.range;
    value.set([v]);
    if (fromInput || shouldUpdateValue(v)) {
      updateValue();
    }
  }
  function addMultipeDate(v, fromInput) {
    var _instance$get4 = instance.get(),
      range = _instance$get4.range;
    var _value = value.value;
    _value = !_value ? [] : _sliceInstanceProperty(_value).call(_value);
    if (range && v.length === 2) {
      // pop the last value firstly, if it only has the start date 
      var lastValue = last(_value);
      if (lastValue && lastValue.length < 2) {
        _value.pop();
      }
    }
    var _shouldUpdateValue = true;
    if (fromInput || shouldUpdateValue(v)) {
      // if select the date/year/month, then toggle the value.
      // if from input, treat the value as the final value
      var index = findValueIndex(_value, v, getEqualType());
      if (index > -1) {
        _spliceInstanceProperty(_value).call(_value, index, 1);
      } else {
        _value.push(v);
      }
    } else {
      // select the datetime, only push the value,
      // and unique the array on click confrim button
      _value.push(v);
      _shouldUpdateValue = false;
    }
    value.set(_value);
    if (_shouldUpdateValue) {
      updateValue();
    }
  }
  function setValue(v, fromInput) {
    var multiple = instance.get('multiple');
    if (multiple) {
      addMultipeDate(v, fromInput);
    } else {
      setSingleDate(v, fromInput);
    }
  }
  function updateValue() {
    var _value = value.value;
    var valueStr = convertToValueString(_value);
    instance.set('value', valueStr);
    instance.resetKeywords(instance.input.keywords);
  }
  function onConfirm() {
    // unique
    if (!instance.get('multiple')) {
      instance.hide();
    } else {
      unique();
      panel.reset();
    }
    updateValue();
  }
  function unique() {
    var _value = value.value;
    var map = {};
    var results = [];
    _value.forEach(function (value) {
      var key;
      if (Array.isArray(value)) {
        key = _mapInstanceProperty(value).call(value, getValueString).join(' ~ ');
      } else {
        key = getValueString(value);
      }
      if (!map[key]) {
        map[key] = true;
        results.push(value);
      }
    });
    value.set(results);
  }
  function isValidDate(date) {
    return date.isValid() && !isDisabled(date, getEqualType());
  }
  function onChangeTime(date, flag) {
    var _context2;
    var _instance$get5 = instance.get(),
      range = _instance$get5.range;
    var values = _sliceInstanceProperty(_context2 = value.value).call(_context2);
    var lastIndex = values.length - 1;
    var _value = date;
    if (range) {
      var _context3;
      _value = _sliceInstanceProperty(_context3 = values[lastIndex]).call(_context3);
      _value[flag] = date;
      instance.trigger('selecting', _value);
    }
    values[lastIndex] = _value;
    value.set(values);
  }
  function getTimeValue(flag) {
    var _value = value.value;
    if (!_value.length) return null;
    var _instance$get6 = instance.get(),
      range = _instance$get6.range,
      min = _instance$get6.min;
    var lastValue = last(_value);
    return range ? lastValue[flag] : lastValue;
  }
  function getDayjsValue() {
    return dayjsValue;
  }
  return {
    value: value,
    format: format,
    onConfirm: onConfirm,
    onChangeTime: onChangeTime,
    getTimeValue: getTimeValue,
    setValue: setValue,
    convertToDayjs: convertToDayjs,
    getDayjsValue: getDayjsValue
  };
}